
import React from 'react';

interface ConsoleTabProps {
  consoleMessages: Array<{type: string, message: string, timestamp: Date}>;
  setConsoleMessages: React.Dispatch<React.SetStateAction<Array<{type: string, message: string, timestamp: Date}>>>;
}

const ConsoleTab: React.FC<ConsoleTabProps> = ({ consoleMessages, setConsoleMessages }) => {
  const getConsoleMessageClass = (type: string) => {
    switch (type) {
      case 'error':
        return 'text-red-500 border-red-200 bg-red-50 dark:bg-red-900/20';
      case 'warn':
        return 'text-yellow-600 border-yellow-200 bg-yellow-50 dark:bg-yellow-900/20';
      case 'info':
        return 'text-blue-500 border-blue-200 bg-blue-50 dark:bg-blue-900/20';
      default:
        return 'text-gray-700 dark:text-gray-300 border-gray-200 bg-white dark:bg-gray-800';
    }
  };
  
  // Format timestamp for console messages
  const formatTime = (date: Date) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
    
    return `${hours}:${minutes}:${seconds}.${milliseconds}`;
  };
  
  return (
    <div>
      <div className="max-h-40 overflow-y-auto">
        {consoleMessages.length > 0 ? (
          consoleMessages.map((msg, index) => (
            <div key={index} className={`mb-1 text-xs p-1 border rounded ${getConsoleMessageClass(msg.type)}`}>
              <div className="flex items-start">
                <span className="text-[10px] text-gray-500 mr-2 font-mono">
                  {formatTime(msg.timestamp)}
                </span>
                <span className="font-mono break-all whitespace-pre-wrap">{msg.message}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="text-gray-500">No console messages captured.</div>
        )}
      </div>
      <div className="mt-2">
        <button
          onClick={() => setConsoleMessages([])}
          className="text-xs px-2 py-1 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 rounded"
        >
          Clear Console
        </button>
      </div>
    </div>
  );
};

export default ConsoleTab;
